export const initialState = {
  isLoading: false,
  locations: [],
};
